// If any import references a json file it scerws up auto import
// Don't put anything else in here
import App from './user-verification-app.config.json';
// import { App } from '@softools/softools-core';
export const UserVerificationAppConfig = App.App;
